import type { FileUploadConfig } from '@pct-ng/feature-file-upload-native';

export const defaultFileUploadConfig: FileUploadConfig = {
  multipleUpload: false,
  removableRow: true,
  showPreview: true,
  multiple: false,
  accept: ['image/webp', 'image/png', 'image/jpeg', 'image/bmp'],
  maxSize: 5 * 1024 * 1024,
} as const;
